import { connect } from "react-redux";
import React, { useEffect } from "react";
import { getAnalytics, logEvent } from "firebase/analytics";
import GridView from "./GridView";
import Paper from "@mui/material/Paper";
import { makeStyles } from "@mui/styles";
import { Network } from "../../fstn/network";
import { Cursor } from "../../fstn/cursor";

const useStyles = makeStyles((theme) => ({

    sheet: {
        margin: theme.spacing(0),
        height: "100%",
        width: "100%"
    }
}));

interface Props
{
    cursor: Cursor
    network: Network
}

function SheetView({ network, cursor }: Props)
{
    const classes = useStyles();

    useEffect(() =>
    {
        logEvent(getAnalytics(), "page_view", {
            page_location: "/sheet"
        });
    }, []);
    return (
        <Paper className={classes.sheet}>
            <GridView network={network} cursor={cursor} />
        </Paper>
    );
}
const mapStateToProps = (store: never) => ({
});

export default connect(mapStateToProps, {
})(SheetView);
